<template>
  <div
    class="travel-extras__item col-md-6"
  >
    <div class="travel-extra__summary-wrapper">
      <div class="travel-extra__summary">
        <div class="travel-extra__header">
          <div class="travel-extra__title-wrapper">
            <h3 class="travel-extra__title">
              {{ extra.name }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 col-lg-12 col-xl-6 travel-extra__description"
            v-html="extra.description"
          />
          <div class="col-md-6 col-lg-6 col-xl-6 travel-extra__values">
            <OfferLineOption
              v-for="(offerLine, index) in extra.offerLines"
              :key="index"
              :disabled="disabled"
              :extra-id="extra.id"
              :is-only-offer="extra.offerLines.length === 1"
              :offer-line-id="offerLine.id"
            />
          </div>
        </div>
      </div>
      <div class="travel-extra__additional-accordion">
        <div class="travel-extra__additional-button">
          <div
            v-show="isMoreVisible"
            class="product__additional-content"
          >
            <div class="row">
              <a
                class="button button--ghost product__info-close"
                @click="isMoreVisible = !isMoreVisible"
              ><span class="visuallyhidden">Close</span></a>
              <div
                class="col-12"
                v-html="extra.moreInformation"
              />
            </div>
          </div>

          <button
            type="button"
            class="btn btn-block"
            data-toggle="modal"
            data-target="#exampleModal"
            @click="toggle"
          >
            {{ isMoreVisible ? 'Less information' : 'More information' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferLineOption from './OfferLineOption'

export default {
    name: 'ExtraOption',
    components: {
        OfferLineOption
    },
    props: {
        extra: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isMoreVisible: false
        }
    },
    computed: {
        price () {
            return this.extra.offerLines
                .reduce((max, o) => o.totalPricePerUnit > max ? o.totalPricePerUnit : max, this.extra.offerLines[0].totalPricePerUnit)
        },
        originalPrice () {
            return this.extra.offerLines
                .reduce((max, o) => o.pricePerUnit > max ? o.pricePerUnit : max, this.extra.offerLines[0].pricePerUnit)
        }
    },
    methods: {
        toggle () {
            this.isMoreVisible = !this.isMoreVisible
        }
    }
}
</script>
